var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "move-stage-config" }, [
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.targetStage")))]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "100%" },
            attrs: { placeholder: _vm.$t("taskModuleRules.selectStage") },
            on: { change: _vm.emitChange },
            model: {
              value: _vm.localConfig.stageId,
              callback: function ($$v) {
                _vm.$set(_vm.localConfig, "stageId", $$v)
              },
              expression: "localConfig.stageId",
            },
          },
          _vm._l(_vm.workflowStages, function (stage) {
            return _c(
              "a-select-option",
              { key: stage._id, attrs: { value: stage._id } },
              [
                _vm._v(
                  "\n                " + _vm._s(stage.name) + "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }